import * as React from 'react';

import { CheckboxGroup, FormCheckConditional, TextInput, Label } from '../../../../../components/forms';
import handleNoneOptionAndValidationHOC from '../handleNoneOptionAndValidationHOC';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
class CancerQuestion extends React.Component<Props> {
	render() {
		const { questions, questionnaire } = this.props;
		const isNextDisabled = function () {
			return !questionnaire[questionName].isValid;
		};
		return (
			<div className="form-group mb-0">
				<Label>{questions[questionName]}</Label>
				<div className="section-base section-bordered mt-1 form-group">
					<CheckboxGroup
						title="Cancer, including:"
						className="mb-2"
						checkOptions={[
							{
								name: 'cancer',
								label: 'Any cancer or tumor except for basal cell carcinoma',
								checked: questionnaire[questionName].cancer,
								onBlur: this.props.onQuestionnaireBlur,
								onChange: this.props.onQuestionnaireChange
							},
							{
								name: 'tumor',
								label: 'Any tumor or growth not yet diagnosed',
								checked: questionnaire[questionName].tumor,
								onBlur: this.props.onQuestionnaireBlur,
								onChange: this.props.onQuestionnaireChange
							},
							{
								name: 'dysplasticNeviSyndrome',
								label: 'Dysplastic nevi syndrome',
								checked: questionnaire[questionName].dysplasticNeviSyndrome,
								onBlur: this.props.onQuestionnaireBlur,
								onChange: this.props.onQuestionnaireChange
							},
							{
								name: 'cancerOther',
								label: 'Other',
								checked: questionnaire[questionName].cancerOther,
								onBlur: this.props.onQuestionnaireBlur,
								onChange: this.props.onQuestionnaireChange,
								conditionalChildren: (
									<FormCheckConditional isOpen={questionnaire[questionName].cancerOther}>
										<TextInput
											labelText="Please specify:"
											name="cancerOtherDetails"
											onBlur={this.props.onQuestionnaireBlur}
											onChange={this.props.onQuestionnaireChange}
											value={questionnaire[questionName].cancerOtherDetails}
											className="mb-2"
										/>
									</FormCheckConditional>
								)
							},
							{
								name: 'cancerNone',
								label: 'None of the above apply to me',
								checked: questionnaire[questionName].cancerNone,
								onBlur: this.props.onQuestionnaireBlur,
								onChange: this.props.onQuestionnaireChange,
								className: 'border-top pt-2'
							},
						]}
					/>
				</div>
				<NextPreviousButtons
					nextStep={this.props.nextStep}
					prevStep={this.props.prevStep}
					isNextDisabled={isNextDisabled}
				/>
			</div>
		);
	}
}

const questionName = 'cancer';
const hocConfig = {
	questionName: questionName,
	otherName: 'cancerOther',
	otherDetailsName: 'cancerOtherDetails'
};
export default handleNoneOptionAndValidationHOC(CancerQuestion, hocConfig);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion1/CancerQuestion.tsx